export enum DocumentErrorCode {
  uniqueName = 'uniqueName',
  totalMaxFilesSize = 'totalMaxFilesSize',
  maxFileSize = 'maxFileSize'
}
